/**
 * Barcode format enum
 */
export enum BarcodeFormat {
  QR_CODE = "QR_CODE",
  DATA_MATRIX = "DATA_MATRIX",
  AZTEC = "AZTEC",
  PDF_417 = "PDF_417",
  EAN_8 = "EAN_8",
  EAN_13 = "EAN_13",
  UPC_A = "UPC_A",
  UPC_E = "UPC_E",
  CODE_39 = "CODE_39",
  CODE_93 = "CODE_93",
  CODE_128 = "CODE_128",
  ITF = "ITF",
  RSS_14 = "RSS_14",
  RSS_EXPANDED = "RSS_EXPANDED",
  CODABAR = "CODABAR",
  MAXICODE = "MAXICODE",
}
